<div class="settings-header">
  <i class="mr-2 fa fa-cog"></i>

  <span class="text-xl font-medium">{{ userSettingsOnly ? 'Benutzer-Einstellungen' : 'System-Einstellungen' }}</span>

  <!-- Favoriten-Button -->
  <div
    jmlFavoriteButton
    [favoriteId]="userSettingsOnly ? 'user-settings' : 'system-settings'"
    [favoriteName]="userSettingsOnly ? 'Benutzer-Einstellungen' : 'System-Einstellungen'"
    [favoriteIcon]="'pi pi-cog'"
    [favoriteRoute]="userSettingsOnly ? '/user-settings' : '/system-settings'"
  ></div>
</div>

<ng-template ngFor let-category [ngForOf]="categories$ | async">
  <p-card styleClass="spacing-bottom-small">
    <div class="flex flex-column">
      <span class="text-2xl font-bold">{{ category.category }}</span>
      <small>{{ category.description }}</small>
      <div class="mb-2"><hr /></div>
      <ng-template ngFor let-setting [ngForOf]="category.settings">
        <div class="settings__item">
          <div class="settings__item__name">
            {{ setting.name }}
            <i *ngIf="setting.description" class="fa fa-info-circle ml-1" [pTooltip]="setting.description"></i>
          </div>
          <div class="settings__item__edit">
            <div class="settings__item__edit__input flex-grow-1 gap-2">
              <div *ngIf="setting.multiline; else singleLine">
                <textarea
                  [rows]="10"
                  [cols]="100"
                  pInputTextarea
                  [(ngModel)]="setting.value"
                  [readonly]="setting.name !== activeEditSetting"
                ></textarea>
              </div>
              <ng-template #singleLine>
                <div *ngIf="!setting.name.includes('PASSWORD'); else password">
                  <input
                    type="text"
                    pInputText
                    [(ngModel)]="setting.value"
                    [readonly]="setting.name !== activeEditSetting"
                  />
                </div>
                <ng-template #password>
                  <div>
                    <input
                      type="password"
                      pInputText
                      [(ngModel)]="setting.value"
                      [readonly]="setting.name !== activeEditSetting"
                    />
                  </div>
                </ng-template>
              </ng-template>
              <div class="flex align-items-stretch flex-grow-1;">
                <p-button
                  *ngIf="setting.name === activeEditSetting && setting.value != setting.defaultValue"
                  pTooltip="Defaultwert setzen"
                  icon="fa fa-mail-reply"
                  (click)="setToDefault(setting)"
                ></p-button>
              </div>
            </div>
            <div class="settings__item__edit__buttons" *ngIf="setting.name === activeEditSetting">
              <p-button pTooltip="Speichern" icon="fa fa-save" (click)="saveSetting(setting)"></p-button>
              <p-button pTooltip="Abbrechen" icon="fa fa-times" (click)="cancelEdit(setting)"></p-button>
            </div>
            <div class="settings__item__edit__buttons" *ngIf="setting.name !== activeEditSetting">
              <p-button
                pTooltip="Bearbeiten"
                icon="fa fa-edit"
                (click)="setActiveForEdit(setting)"
                [disabled]="!!activeEditSetting"
                *ngIf="setting.value != setting.default"
              ></p-button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </p-card>
</ng-template>

<ng-template [ngIf]="!this.userSettingsOnly">
  <p-card styleClass="spacing-bottom-small">
    <span class="text-2xl font-bold">Aktionen</span>
    <div class="mb-2"><hr /></div>
    <div class="grid">
      <div class="col-4 flex align-items-center">Ping Nextcloud</div>
      <div class="col-8">
        <div class="grid">
          <div class="col-10">
            <label></label>
          </div>
          <div class="col-2">
            <p-button pTooltip="Ping" icon="pi pi-reply" (click)="pingNextcloud()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </p-card>
</ng-template>
